const nav = require('./partials/nav.hbs');
const navEmbed = require('./partials/nav_embed.hbs');
const logo = require('./partials/logo.hbs');
const logoEmbed =require('./partials/logo_embed.hbs');
const preloader =require('./partials/preloader.hbs');
const contacto =require('./partials/contacto.hbs');
const dataFiscal =require('./partials/dataFiscal.hbs');
const comboDigital =require('./partials/combo/acceso_digital.hbs');
const comboDigitalCredencial =require('./partials/combo/acceso_digital_credencial.hbs');
const comboNYT =require('./partials/combo/nyt.hbs');
const comboTengoClub =require('./partials/combo/tengo_club.hbs');
const headerLimiteNotas =require('./partials/header/limite_notas.hbs');
const headerSuscribite =require('./partials/header/suscribite.hbs');
const headerPlanInsuficiente =require('./partials/header/plan_insuficiente.hbs');
const headerSinSuscripcion =require('./partials/header/sin_suscripcion.hbs');
const headerSinAccesoPDF =require('./partials/header/sin_acceso_pdf.hbs');
const headerPDFSinSuscripcion =require('./partials/header/pdf_sin_suscripcion.hbs');
const footerPreguntasFrecuentes =require('./partials/preguntas_frecuentes.hbs');
const suscripcionDiario =require('./partials/suscripcion_diario.hbs');
const actualizarSuscripcion = require('./partials/actualizar_suscripcion.hbs');


(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (Handlebars) {
    'use strict';

    //todos los encodings
    //http://www.thesauruslex.com/typo/eng/enghtml.htm

    Handlebars.registerPartial('Wall.Nav', nav);

    Handlebars.registerPartial('Wall.Nav.Embed', navEmbed);

    Handlebars.registerPartial('Header.Logo', logo);

    Handlebars.registerPartial('Header.Logo.Embed', logoEmbed);

    Handlebars.registerPartial('Preloader', preloader);

    Handlebars.registerPartial('Wall.Contacto', contacto);

    Handlebars.registerPartial('Wall.DataFiscal', dataFiscal);

    Handlebars.registerPartial('Wall.Combo.AccesoDigital', comboDigital);

    Handlebars.registerPartial('Wall.Combo.AccesoDigitalCredencial', comboDigitalCredencial);

    Handlebars.registerPartial('Wall.Combo.NYT', comboNYT);

    Handlebars.registerPartial('Wall.Combo.TengoClub', comboTengoClub);

    Handlebars.registerPartial('Wall.Header.LimiteNotas', headerLimiteNotas);

    Handlebars.registerPartial('Wall.Header.Suscribite', headerSuscribite);

    Handlebars.registerPartial('Wall.Header.PlanInsuficiente', headerPlanInsuficiente);
    
    Handlebars.registerPartial('Wall.Header.SinSuscripcion', headerSinSuscripcion);

    Handlebars.registerPartial('Wall.Header.SinAccesoPDF', headerSinAccesoPDF);    

    Handlebars.registerPartial('Wall.Header.PDFSinSuscripcion', headerPDFSinSuscripcion);        

    Handlebars.registerPartial('Wall.Footer.PreguntasFrecuentes', footerPreguntasFrecuentes);

    Handlebars.registerPartial('Wall.SuscripcionDiario', suscripcionDiario);

    Handlebars.registerPartial('Wall.ActualizarSuscripcion', actualizarSuscripcion);

    

})(Handlebars);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/views/partials.js